import React from 'react';
import { Field, Form, Formik, FormikHelpers } from 'formik';
import * as Yup from 'yup';

import Button from '@material-ui/core/Button';
import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import DialogPaper from '../DialogPaper';

// import * as StampCardService from '../../api/stampCardService';
import TextField from '../FormikAdapter/TextField';
import useCompanyContext from '../../hooks/useCompanyContext';

export interface Values {
  selectedNum: number;
}

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    width: 150,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(2),
    width: 300,
  },
  title: {
    marginTop: theme.spacing(3),
    fontWeight: theme.typography.fontWeightBold,
    textAlign: 'center',
    marginBottom: theme.spacing(3),
  },
}));
//------------------------------------------------------------------------------
// Validation
//------------------------------------------------------------------------------

type Props = Pick<DialogProps, 'open' | 'onClose'> & {
  confirmSelectedNumber: (selectedNum: string) => void;
  maxSelectedNumber?: number;
};

export default function SelectOtherNumberDialog({
  onClose,
  open,
  confirmSelectedNumber,
  maxSelectedNumber,
}: Props) {
  const { company } = useCompanyContext();
  const classes = useStyles();

  const initialValues: Values = {
    selectedNum: 8,
  };

  const handleSubmit = async (values: Values, _: FormikHelpers<Values>) => {
    try {
      if (company) {
        confirmSelectedNumber(values.selectedNum.toString());
      }
    } catch (e) {
      console.log(e);
    }
  };

  const ValidationSchema = Yup.object().shape({
    selectedNum: Yup.number()
      .required('Required')
      .integer('Only whole number')
      .moreThan(7, 'Must be greater than 7')
      .lessThan(
        maxSelectedNumber ? maxSelectedNumber + 1 : 20,
        `Max ${
          maxSelectedNumber && maxSelectedNumber > 1
            ? maxSelectedNumber.toString()
            : '20'
        }`
      ),
  });

  return (
    <Dialog open={open} onClose={onClose} PaperComponent={DialogPaper}>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={ValidationSchema}
        enableReinitialize={true}
      >
        {({ isSubmitting, values: { selectedNum } }) => {
          return (
            <Form noValidate autoComplete="off">
              <div className={classes.cardContainer}>
                <Typography variant="h6" className={classes.title} gutterBottom>
                  Select Other Number
                </Typography>
                <Field
                  component={TextField}
                  name="selectedNum"
                  label=""
                  autoFocus
                  required
                />
                <Button
                  type="submit"
                  color="primary"
                  className={classes.buttonContainer}
                  disabled={isSubmitting}
                >
                  CONFIRM
                </Button>
              </div>
            </Form>
          );
        }}
      </Formik>
    </Dialog>
  );
}
